module.exports = __webpack_public_path__ + "img/anime4.79db08ba.png";